// Defined set of valid refund reasons
type SurfboardRefundReason =
  | 'CUSTOMER_INITIATED_RETURN'
  | 'SUSPECTED_MALFUNCTION'
  | 'SUSPECTED_FRAUD'
  | 'DUPLICATE_TRANSACTION'
  | 'OTHER';

// Defined set of valid payment methods
type SurfboardPaymentMethod =
  | 'CARD'
  | 'CARD_NP'
  | 'KLARNA'
  | 'CTOKEN'
  | 'GIFTCARD';

// https://developers.surfboardpayments.com/api/payments?lang=Node.js#Initiate-a-Payment
export interface SurfboardRefundPayment {
  /** The unique identifier for the order. **Required**. */
  orderId: string;

  /** The payment method used for the original transaction or refund. **Required**. */
  paymentMethod: SurfboardPaymentMethod;

  /** The specific reason why the refund/return was initiated. **Required**. */
  refundReason: SurfboardRefundReason;

  /** Additional details, mandatory when refundReason is 'OTHER', otherwise this field is optional. */
  otherReason?: string;
}


export interface SurfboardFullPayment {
  /** Specifies the Order ID of the order. **Required**. */
  orderId: string;

  /** Specifies the payment method. **Required**. */
  paymentMethod: SurfboardPaymentMethod;

  /** * The amount in the smallest currency unit.
   * This is **optional** overall, but required for purchase transactions.
   */
  amount?: number;

  /** * The Original Purchase Payment ID.
   * This is **conditional** (mandatory for certain partial refunds).
   */
  purchasePaymentId?: string;

  /** * Token ID.
   * This is **conditional** (mandatory if CTOKEN is used).
   */
  tokenId?: string;

  /** * The reason for the return request.
   * This is **conditional** (mandatory for CARD_NP refunds).
   */
  refundReason?: SurfboardRefundReason;

  /** * Description of the reason.
   * This is **conditional** (mandatory when refundReason is 'OTHER').
   */
  otherReason?: string;
}

export type SurfboardPayment = SurfboardFullPayment | SurfboardRefundPayment;